import React from 'react';
import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material';

/**
 * Props that we do not want to include with Menu.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type MenuBlockedProps = keyof Pick<MuiMenuProps, 'elevation'>;

export type MenuProps = Omit<MuiMenuProps, MenuBlockedProps>;

export const Menu = React.forwardRef<HTMLDivElement, MenuProps>(
  function UnifyMenu(props, ref) {
    return <MuiMenu {...props} ref={ref} />;
  }
);
